import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-index",
  "use": "icon-index-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-index\"><path d=\"M20,22 C22.5679713,22 24.8365151,23.3895758 26.054777,25.4842997 L27,25.4842997 L27,36 L36,36 L36,16.545309 L20,4.7293928 L4,16.545309 L4,36 L13,36 L13,25.4842997 L13.945223,25.4842997 C15.1634849,23.3895758 17.4320287,22 20,22 Z M24,39 L24,28.4842997 C23.7140675,26.5187508 22.0343954,25 20,25 C17.9656046,25 16.2859325,26.5187508 16.0329362,28.4842997 L16,39 L1,39 L1,15.0314005 L20,1 L39,15.0314005 L39,39 L24,39 Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/index.svg
// module id = z8O7
// module chunks = 28